import '../styles/hero-one.css'
import '../styles/top-nav.css'
import '../styles/section-cta.css'
import '../styles/footer.css'
import '../styles/large-centered-text.css'
import '../scripts/navigation.js'
import '../styles/section-rich-text.css'
import '../styles/cta-pill-section.css'

import TopNav from '../scripts/navigation.js'

const handleMenu = new TopNav();

const dropdownTrigger = document.querySelectorAll('.dropdown-trigger')
const dropdown = document.querySelectorAll('.dropdown')

dropdown.forEach(trigger => {
	const dropdownContent = trigger.children[1];
	trigger.addEventListener('mouseover', e => {
		dropdownContent.classList.add('active')
	})

	trigger.addEventListener('mouseout', e => {
		dropdownContent.classList.remove('active')
	})
})
